module.exports = __webpack_public_path__ + "img/settings.16c4ff31.svg";